import { ParamIds, Places } from 'src/Constants'
import { UserManagerFormKeys } from '../um_form_keys'

export class UserChangePasswordFormKeys extends UserManagerFormKeys {
    get place() {
        return Places.userChangePasswordForm
    }

    get origin() {
        return this._intent.getParameterAsString(ParamIds.userPassChangeOrigin)
    }

    set origin(value: string | undefined) {
        this._intent.setParameter(ParamIds.userPassChangeOrigin, value)
    }
}
